<template>
    <b-card>
        <div class="search">
           <div class="border-bottom">
                <b-card-header class="pt-0 pb-1">
                    <b-card-title>
                        <h1 class="text-primary"> MAS Screening </h1>
                    </b-card-title>

                    <b-button
                        variant="primary"
                        :class="!shouldDisabledGetReportBtn ? 'enable-report' : 'disabled-report'"
                        :disabled="shouldDisabledGetReportBtn"
                        @click="generateReport"
                    >
                        <span v-if="generatingReport" class="d-flex align-items-center">
                            Download in progress
                            <normal-loader />
                        </span>

                        <span v-else class="d-flex align-items-center">
                            Get Report
                        </span>
                    </b-button>
                </b-card-header>
           </div>

            <b-card-body class="search-body mt-1">
                <b-form-group>
                    <b-input-group class="input-group-merge">
                        <b-form-input
                            id="search"
                            v-model="search"
                            class="form-control-merge dont-capitalize"
                            type="text"
                            name="search"
                            data-test="search"
                            placeholder="Search for a person or a company"
                            @keyup.enter="getMasScreeningResult"
                            @input="handleSearchChange"
                        />
                        <b-input-group-append is-text>
                           <div class="search-icon">
                                 <feather-icon
                                    icon="SearchIcon"
                                    width="18"
                                    height="18"
                                    @click="getMasScreeningResult"
                                />
                           </div>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>

                <div v-show="shouldShowScreeningLogo">
                    <div style="width:60%; margin:auto;">
                        <div class="d-flex justify-content-center " >
                            <img
                                class="img-fluid"
                                alt="sanctions-list"
                                src="/illustrations/screening_illustration.png"
                            />
                        </div>
                    </div>

                    <!-- <div class="mt-1 h3">
                        Perform your sanction checks  by accessing a myriad of official government sources from around the globe.
                    </div> -->
                </div>

                <div v-show="showEmptyScreeningMessage" class="empty-result-message mt-4" style="margin-bottom:-55px;">
                    <h2> Good news. We were not able to find any matches for your search.</h2>
                    <!-- <div style="font-size:14.5px">
                        If you are still in doubt whether or not the searched counterparty is eligible to do business with or if you know that the counterparty should appear on a sanction list, mail us to <strong> admin@enston.com </strong>.
                    </div> -->
                </div>

                <mas-screening-result
                    :mas-screening-result="masScreeningResult" 
                    :is-loading="isLoading"
                    :search="search"
                />

            </b-card-body>
        </div>
    </b-card>
</template>

<script>
import {
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    BFormInput,
    BCard,
    BButton,
    BCardHeader,
    BCardTitle,
    BCardBody,
} from "bootstrap-vue";
import Compliance from '@/models/Compliance';
import { localizeIndividual, localizeEntities }  from '@/localize/categoryRelatedDetailLocalizer';
import { errorToast } from '@/views/helpers/toast';
import { SOMETHING_WENT_WRONG } from "@/constants/errors";
import MasScreeningResult from './MasScreeningResult.vue';
// import masScreeningResult from '@/__mocks__/compliance/masScreeningResult';

export default {
    components: {
        BFormGroup,
        BInputGroup,
        BInputGroupAppend,
        BFormInput,
        BCard,
        BButton,
        BCardHeader,
        BCardTitle,
        BCardBody,

        MasScreeningResult,
    },

    data() {
        return {
            isLoading: false,
            search: "",
            masScreeningResult : [],
            shouldDisabledGetReportBtn: true,
            showEmptyScreeningMessage: false,
            generatingReport: false,
            shouldShowScreeningLogoData: true
        };
    },

    computed: {
        shouldShowScreeningLogo() {
            if (this.isLoading || this.generatingReport || this.masScreeningResult.length > 0 || this.showEmptyScreeningMessage) 
                return false;
            return true;
        }
    },

    methods: {
        handleSearchChange() {
            this.shouldDisabledGetReportBtn = true;

            if (this.search.length <= 0) {
                this.masScreeningResult = [];
                this.showEmptyScreeningMessage = false;
            }
        },

        getMasScreeningResult() {
            this.shouldDisabledGetReportBtn = true;
            this.showEmptyScreeningMessage = false;

            if(this.search.length > 0) {
                this.isLoading = true;

                Compliance.masScreening(this.search)
                    .then(searchResult => {
                        this.masScreeningResult = [];
                        const tempStore = [];

                        Object.keys(searchResult).forEach(key => {
                            searchResult[key].forEach(data => {
                                if(key === 'individuals') {
                                    tempStore.push(localizeIndividual(data));
                                } else if( key === 'entities' ) {
                                    tempStore.push(localizeEntities(data));
                                }
                            });
                        });
                        this.masScreeningResult = tempStore;

                        if(this.masScreeningResult.length < 1) {
                            this.showEmptyScreeningMessage = true;
                        }

                        this.shouldDisabledGetReportBtn = false;
                        this.isLoading = false;
                    })
                    .catch(error => {
                        this.isLoading = false;
                        console.log(error);
                    });
            } else {
                this.masScreeningResult = [];
                this.shouldDisabledGetReportBtn = true;
                this.showEmptyScreeningMessage = false;
            }
        },

        generateReport() {
            this.generatingReport = true;
            this.shouldDisabledGetReportBtn = true;

            Compliance.generateReport(this.search)
                .then(response => {
                    this.generatingReport = false;
                    this.shouldDisabledGetReportBtn = false;

                    const url = window.URL.createObjectURL(new Blob([response], {type:'application/octet-stream'}));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `MAS Screening - ${this.search}.pdf`);
                    document.body.appendChild(link);
                    link.click();
                })
                .catch(error => {
                    this.generatingReport = false;
                    this.shouldDisabledGetReportBtn = false;
                    errorToast(SOMETHING_WENT_WRONG);
                    console.log("Error while trying to generate report", error);
                });
        },
    },
};
</script>

<style scoped>
#search {
    font-size: 14px;
    padding: 20px 15px;
}
#search::placeholder {
    font-size: 14px;
}

.search-icon {
    width: 29px;
    height: 29px;
    padding-top: 3px;
    display: inline-block;
    border-radius: 25px;
    cursor: pointer;
}
.search-icon:hover {
    background: #dee6f275;
}

.disabled-report {
    transition: .3s ease-in-out;
    opacity: .3;
}

.enable-report {
    transition: .3s ease-in-out;
    opacity: 1;
}

.loader-container {
    margin-left: 0px!important;
    left: 17px;
}
</style>
